import gql from "graphql-tag";

export const viewCollectionData = gql`
  query viewCollectionData($input: ViewCollectionInput!) {
    viewCollectionData(input: $input) {
      presignedUrl
    }
  }
`;

export const viewCollectionDataOptions = {
  name: "viewCollectionDataData",
};
